import React, { useState, useCallback } from "react";
import { Button, Card, Collapse, Alert, Spinner } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";
import { userActions } from "../../../core/users";

export const YourReport = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const { isPending } = useSelector(state => state.questionnaire_resume);
    const [showTip, setShowTip] = useState(false);
    const [showBtn, setShowBtn] = useState(true);
    const toggleShowTip = useCallback(() => {
        if (!user?.can_download_pdf) {
            setShowTip(prev => !prev);
        }
    }, [user]);

    const handleDownload = useCallback((e) => {
        e.stopPropagation();

        if (!user?.can_download_pdf) {
            toggleShowTip();
            return;
        }

        dispatch(userActions.fetchFullPdf(user.id));
    }, [dispatch, user, toggleShowTip, userActions]);

    return (
        <Card color="ice-60" className="p-3 border-ice-60" onClick={toggleShowTip}>
            <div className="d-lg-flex align-items-center justify-content-between">
            <p className="mb-0 font-weight-medium">You can download the full report once you have completed all assessments.</p>

            {showBtn && <Button color="link" size="sm" onClick={handleDownload} disabled={isPending} className={`btn text-dark btn-sm btn-green-light ${user?.can_download_pdf ? '' : 'text-muted disabled'}`}>
                {isPending
                    ?
                        <Spinner
                            color="primary"
                            className="mr-2"
                            size="sm"
                        >
                            Loading...
                        </Spinner>
                    : <i className="mr-2 pb-1">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="11" width="11" viewBox="0 0 10.94 10.94">
                            <path d="M10.94,6.78v3.5c0,.17-.07,.34-.19,.46-.12,.12-.29,.19-.46,.19H.66c-.17,0-.34-.07-.46-.19-.12-.12-.19-.29-.19-.46v-3.5c0-.17,.07-.34,.19-.46,.12-.12,.29-.19,.46-.19s.34,.07,.46,.19c.12,.12,.19,.29,.19,.46v2.84H9.62v-2.84c0-.17,.07-.34,.19-.46,.12-.12,.29-.19,.46-.19s.34,.07,.46,.19c.12,.12,.19,.29,.19,.46Zm-5.93,.46c.06,.06,.13,.11,.21,.14,.08,.03,.17,.05,.25,.05s.17-.02,.25-.05,.15-.08,.21-.14l2.19-2.19c.12-.12,.19-.29,.19-.46s-.07-.34-.19-.46c-.12-.12-.29-.19-.46-.19s-.34,.07-.46,.19l-1.07,1.07V.66c0-.17-.07-.34-.19-.46-.12-.12-.29-.19-.46-.19s-.34,.07-.46,.19c-.12,.12-.19,.29-.19,.46V5.2l-1.07-1.07c-.06-.06-.13-.11-.21-.14-.08-.03-.17-.05-.25-.05-.17,0-.34,.07-.46,.19-.06,.06-.11,.13-.14,.21-.03,.08-.05,.17-.05,.25,0,.17,.07,.34,.19,.46l2.19,2.19Z"/>
                        </svg>
                    </i>
                }
                <span className="d-inline-block" style={{ verticalAlign: 'middle', fontWeight: '600' }}>Download Full Report</span>
            </Button>}

            <Collapse
                className="pb-0"
                isOpen={showTip && !user?.can_download_pdf}
                onEntering={() => setShowBtn(false)}
                onExited={() => setShowBtn(true)}
            >
                    <Alert
                        className="mb-0"
                        color="info"
                    >
                        <Button color="link" className="p-0 close icon-close mt-1"></Button>
                        You must first complete all the assessments to access your report.
                    </Alert>
            </Collapse >
            </div>
        </Card>
    )
}
